<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="بولا-بولس-ربيز-شاعرة-الياسمين">
<h1><span dir="rtl">بولا بولس ربيز (شاعرة الياسمين)</span></h1>
<p><span dir="rtl">وُلدَت بولا ربيز (شاعرة الياسمين) في لبنان "رأس بيروت"</span> <span dir="rtl">ودرسَتِ العلوم السياسيَّة في الجامعة الأمريكية في بيروت.</span></p>
<p><span dir="rtl">حصلَت لاحقًا على درجة الماجستير في الشؤون الدولية والدراسات الإستراتيجيَّة العسكرية مِن جامعة كينجز كولدج - لندن في بريطانيا.</span></p>
<p><span dir="rtl">تعيش حاليًّا في الإمارات العربية المتحدة، وتمتلك شركة تجارية.. هي مجازة مِن مدينة دبي للإعلام كصحافية وكاتبة.</span></p>
<p><span dir="rtl">اشتُهرَت منذ الصِّغر بحبِّها الشديد للشعر والنثر</span> <span dir="rtl">قرأتِ الدواوين مِن شعراء الجاهليَّة حتَّى العصر الحديث أبدعَت بعشقها للغة العربية وتعلُّقها بكلِّ حرف وكلمة.</span></p>
<p><span dir="rtl">تُعدُّ رحلة الكتابة فرصة للتعبير عن أفكارها ومشاعرها ومشاركة عالمها الداخلي مع الآخَرين.</span></p>
<p><span dir="rtl">تتطلَّع إلى أن تلهِم القُرَّاء بأفكارها وتجاربها وتسعى لتعزيز دور المرأة في المجتمع.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?aa95a0c4